/* eslint-disable camelcase */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-use-before-define */
import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../App.css';
import { DataGrid, GridLogicOperator, gridClasses, GridToolbarContainer, GridToolbarExport, GridToolbarFilterButton, GridToolbarColumnsButton, GridToolbarDensitySelector, GridToolbarQuickFilter } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import { Paper, Typography } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import CircularProgress from '@mui/material/CircularProgress';
import { AiOutlineMenu } from 'react-icons/ai';
import { MdKeyboardArrowDown } from 'react-icons/md';
import { makeStyles } from '@mui/styles';
import Swal from 'sweetalert2';
import SimpliSafe from '../data/SimpliSafe.png';
import avatar_1 from '../data/avatar_1.png';
import Sidebar from '../components/Sidebar';
import { useStateContext } from '../contexts/ContextProvider';

const columns = [{ field: 'RA_Number', headerName: 'RA Number', width: 250, type: 'number', headerAlign: 'center', align: 'center' },
  { field: 'Tracking_No', headerName: 'Tracking No', width: 250, type: 'number', headerAlign: 'center', align: 'center' },
  { field: 'Item_Number', headerName: 'Item Number', width: 250, headerAlign: 'center', align: 'center' },
  { field: 'Quantity', headerName: 'Quantity', width: 250, type: 'number', headerAlign: 'center', align: 'center' },
  { field: 'Request_Date', headerName: 'Request Date', width: 250, type: 'Date', headerAlign: 'center', align: 'center' },
];
const useStyles = makeStyles({
  columnsButton: {
    scale: 1.25,
    padding: '8px', // customize the padding to adjust the size
  },
});
function CustomToolbar() {
  const classes = useStyles();
  return (
    <div className="container-fluid">
      <div className="row">
        <GridToolbarContainer>
          <div className="col-xs-8 col-sm-6 col-md-4 col-lg-2">
            <GridToolbarColumnsButton className={classes.columnsButton} />
          </div>
          <div className="col-xs-8 col-sm-6 col-md-4 col-lg-2">
            <GridToolbarDensitySelector className={classes.columnsButton} />
          </div>
          <div className="col-xs-8 col-sm-6 col-md-4 col-lg-2">
            <GridToolbarFilterButton className={classes.columnsButton} />
          </div>
          <div className="col-xs-8 col-sm-6 col-md-4 col-lg-2">
            <GridToolbarExport
              csvOptions={{
                fileName: 'custFilename',
              }}
              className={classes.columnsButton}
            />
          </div>
          <div id="quick_search">
            <GridToolbarQuickFilter />
          </div>
        </GridToolbarContainer>
      </div>
    </div>
  );
}

const ODD_OPACITY = 0.2;

const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
  [`& .${gridClasses.row}.even`]: {
    backgroundColor: theme.palette.grey[200],
    '&:hover, &.Mui-hovered': {
      backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
      '@media (hover: none)': {
        backgroundColor: 'transparent',
      },
    },
    '&.Mui-selected': {
      backgroundColor: alpha(
        theme.palette.primary.main,
        ODD_OPACITY + theme.palette.action.selectedOpacity,
      ),
      '&:hover, &.Mui-hovered': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          ODD_OPACITY
            + theme.palette.action.selectedOpacity
            + theme.palette.action.hoverOpacity,
        ),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: alpha(
            theme.palette.primary.main,
            ODD_OPACITY + theme.palette.action.selectedOpacity,
          ),
        },
      },
    },
  },
}));

const NavButton = ({ customFunc, icon, color, dotColor }) => (
  <button
    type="button"
    onClick={() => customFunc()}
    style={{ color }}
    className="relative text-xl rounded-full p-3 hover:bg-light-gray"
  >
    <span
      style={{ background: dotColor }}
      className="absolute inline-flex rounded-full h-2 w-2 right-2 top-2"
    />
    {icon}
  </button>
);

const InbounRa = () => {
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(
    new Date(new Date(new Date().getTime()).setDate(new Date().getDate() - 1)),
  );
  const [endDate, setEndDate] = useState(
    new Date(new Date(new Date().getTime()).setDate(new Date().getDate() - 1)),
  );
  const [tableData, setTableData] = useState([]);
  const { activeMenu, themeSettings } = useStateContext();
  useEffect(() => {
    InboundTable();
  }, [startDate, endDate]);
  const {
    currentColor,
    setActiveMenu,
    handleClick,
    setScreenSize,
    screenSize,
  } = useStateContext();

  useEffect(() => {
    const handleResize = () => setScreenSize(window.innerWidth);

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (screenSize <= 900) {
      setActiveMenu(false);
    } else {
      setActiveMenu(true);
    }
  }, [screenSize]);

  // useEffect(() => {
  //   let timeoutId;
  //   const startTimer = () => {
  //     timeoutId = setTimeout(() => {
  //       localStorage.removeItem('loginID');
  //       navigate('/');
  //       Swal.fire({
  //         icon: 'error',
  //         title: 'Oops...',
  //         text: 'Your session has timed out due to inactivity!',
  //       });
  //     }, 30000);
  //   };

  //   const resetTimer = () => {
  //     clearTimeout(timeoutId);
  //     startTimer();
  //   };

  //   document.addEventListener('mousemove', resetTimer);
  //   document.addEventListener('keydown', resetTimer);

  //   startTimer();

  //   return () => {
  //     document.removeEventListener('mousemove', resetTimer);
  //     document.removeEventListener('keydown', resetTimer);
  //     clearTimeout(timeoutId);
  //   };
  // }, [startDate, endDate]);

  const handleActiveMenu = () => setActiveMenu(!activeMenu);
  const InboundTable = () => {
    setLoading(true);
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    const raw = JSON.stringify({
      FromDate: startDate,
      ToDate: endDate,
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    fetch('http://localhost:27303/API/InboundRARequest', requestOptions)
      .then((response) => response.text())
      .then((result) => {
        setTableData(JSON.parse(result));
        setLoading(false);
      });
    // .then('error', swal('NO data', { icon: 'error' }));
    if (startDate === null || endDate === null) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Please Select Date!',
      });
      setStartDate(new Date(new Date(new Date().getTime()).setDate(new Date().getDate() - 1))); // for compulsory dates
      setEndDate(new Date(new Date(new Date().getTime()).setDate(new Date().getDate() - 1))); // for compulsory dates
    }
  };
  const disableFutureDates = (date) => date.getTime() < new Date().getTime();

  return (
    <div className="flex relative dark:bg-main-dark-bg">
      {activeMenu ? (
        <div className="w-72 fixed sidebar dark:bg-secondary-dark-bg bg-white">
          <Sidebar />
        </div>

      ) : (
        <div className="w-0 dark:bg-secondary-dark-bg">
          <Sidebar />
        </div>
      )}
      {/* <div
        className={
          activeMenu
            ? 'dark:bg-main-dark-bg  bg-main-bg min-h-screen md:ml-72 w-full  '
            : 'bg-main-bg dark:bg-main-dark-bg  w-full min-h-screen flex-2 '
        }
      > */}
      <div style={{ width: `${activeMenu ? '100%' : '100%'} `, paddingLeft: `${activeMenu ? '300px' : '0px'}` }}>
        <div
          className="fixed md:static bg-main-bg dark:bg-main-dark-bg navbar w-full "
          // style={{ background: 'linear-gradient(to right, #060047 , #00FFFF  )', borderRadius: '10px' }}
          style={{
            background: 'linear-gradient(to right, #060047 , #00FFFF  )',
            borderBottomLeftRadius: '10px',
            borderBottomRightRadius: '10px',
          }}
          id="navMenu_id"
        >
          <div className="container-fluid">
            <div className="flex justify-between p-2 md:ml-4 md:mr-4 relative">
              <NavButton
                title="Menu"
                customFunc={handleActiveMenu}
                color={currentColor}
                icon={<AiOutlineMenu />}
              />
              <div>
                <img style={{ height: '50px' }} src={SimpliSafe} alt="logo" />
              </div>
            </div>
            <div className="flex">
              <div
                style={{ backgroundColor: '#EEEEEE' }}
                className="flex items-center gap-2 cursor-pointer p-1 hover:bg-light-gray rounded-lg"
                onClick={() => handleClick('userProfile')}
              >
                <img
                  className="rounded-full w-8 h-8"
                  src={avatar_1}
                  alt="user-profile"
                />
                <p>
                  <span className="text-gray-400 text-14">Hi,</span>{' '}
                  <span className="text-black-400 font-bold ml-1 text-14">
                    {JSON.parse(localStorage.getItem('loginID')) === null
                    || undefined
                      ? null
                      : JSON.parse(localStorage.getItem('loginID')).UserName}
                  </span>
                </p>
                <MdKeyboardArrowDown className="text-gray-400 text-14" />
              </div>
            </div>
          </div>
          {/* style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}   // col-xs-8 col-sm-6 col-md-4 col-lg-2// */}
          <div className="container-fluid row" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <div className="row col-xs-10 col-sm-10 col-md-8 col-lg-5" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px', marginBottom: '-90px', marginTop: '-60px' }} id="datePicker_id2">
              <div className="col-xs-8 col-sm-6 col-md-4 col-lg-1">
                <Typography variant="h6" component="h2" color="">
                  From
                </Typography>
              </div>
              <div className="col-xs-8 col-sm-6 col-md-4 col-lg-4">
                <DatePicker
                  id="datePicker_id"
                  className="border border-gray-400 p-2 rounded-md text-gray-800 text-sm"
                  dateFormat="dd/MM/yyyy"
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  selectsStart
                  startDate={startDate}
                  endDate={endDate}
                  peekNextMonth
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  placeholderText="Start date"
                  autoComplete="off"
                  filterDate={disableFutureDates}
                  excludeDates={[new Date()]}
                />
              </div>
              <div className="col-xs-8 col-sm-6 col-md-4 col-lg-1">
                <Typography variant="h6" component="h2" color="">
                  To
                </Typography>
              </div>
              <div className="col-xs-8 col-sm-6 col-md-4 col-lg-4">
                <DatePicker
                  id="datePicker_id"
                  className="border border-gray-400 p-2 rounded-md text-gray-800 text-sm"
                  dateFormat="dd/MM/yyyy"
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                  selectsEnd
                  startDate={startDate}
                  endDate={endDate}
                  minDate={startDate}
                  peekNextMonth
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  placeholderText="End date"
                  autoComplete="off"
                  filterDate={disableFutureDates}
                  excludeDates={[new Date()]}
                />
              </div>

            </div>
          </div>
        </div>
        <div>
          {themeSettings}
          <div className="container-fluid">
            <div>
              <Paper
                style={{
                  height: 850,
                  width: '100%',
                  // margin: '10px 10px 10px 0',
                  backgroundColor: '#ECF2FF',
                  borderRadius: '25px',
                  padding: '10px',
                  marginTop: '20px',
                }}
              >

                {loading ? (
                  <Box sx={{ display: 'flex', justifyContent: 'center', justifyItems: 'end', marginTop: '100px' }}>
                    <CircularProgress thickness={4} size={60} />
                    <Typography variant="h6" sx={{ marginTop: '20px' }}> {' '}Loading...</Typography>
                  </Box>
                ) : (
                  <Box
                    sx={{
                      height: 800,
                      width: '99%',
                      backgroundColor: '#FFFFFF',
                      margin: '10px 10px',
                      borderRadius: '20px',
                    }}
                    id="table_positions"
                  >
                    <StripedDataGrid
                      sx={{ borderRadius: '20px' }}
                      rows={tableData}
                      columns={columns}
                      getRowId={(row) => row.row}
                      components={{ Toolbar: CustomToolbar }}
                      checkboxSelection
                      // rowsPerPageOptions={[50, 100, 200]}
                      getRowClassName={(params) => (params.indexRelativeToCurrentPage % 2 === 0
                        ? 'even'
                        : 'odd')}
                      initialState={{
                        filter: {
                          filterModel: {
                            items: [],
                            quickFilterLogicOperator: GridLogicOperator.Or,
                          },
                        },
                      }}
                    />
                  </Box>
                )}
              </Paper>
            </div>
          </div>
        </div>
        {/* <Footer /> */}
      </div>
    </div>
  );
};

export default InbounRa;
